import type {
  BilingualFallbackType,
  TeacherType,
} from '@openeducation/oe-rn-shared-types';
import axios from 'axios';

import type { Environment } from '../interfaces';
import { hostsConfig } from '../utils';

export default abstract class BilingualTeacherDAO {
  static async updatePreferredTeacherType(
    env: Environment,
    personId: number,
    preferredTeacherType: TeacherType,
    fallBackLiveClassTeacherType?: BilingualFallbackType
  ) {
    const url = hostsConfig[env].profileServiceUrl;

    const { data } = await axios.put(`${url}/v1/persons/specific`, {
      preferredTeacherType,
      fallBackLiveClassTeacherType,
      personId,
    });

    return data;
  }

  static async setOnboardingTaken(env: Environment, personId: number) {
    const url = hostsConfig[env].profileServiceUrl;

    const { data } = await axios.put(`${url}/v1/persons/specific`, {
      lcOnboardingTaken: true,
      personId,
    });

    return data;
  }
}
